<template>
  <div class="about-section-component">
    <div class="container">
      <div class="row no-gutters about-section">
        <div class="col-12 col-md-6">
          <div class="about-section-image"></div>
        </div>
        <div class="col-12 col-md-6">
          <div class="about-section-text">
            <div class="row">
              <div class="col-12">
                <div class="about-text">
                  <h2>
                    We make
                    <br />chocolates we <br />love to eat!
                  </h2>
                  <p>
                    <a href="/about">
                      Know more about our story -
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<style lang="sass" scoped>
.about-section-component
  margin-top: 8rem
  margin-bottom: 8rem

.about-section
  min-height: 20rem
  height: auto

.about-section-image
  background-image: url('../../assets/images/home/about.jpg')
  background-position: center !important
  background-size: cover !important
  background-repeat: no-repeat
  width: 100%
  height: 14rem

.about-section-text
  background-color: $dutche-primary-violet
  height: 14rem
  h2
    color: $white
    font-size: 2em
    font-family: "Might Could"
  a, p
    color: $white
    text-decoration: none
  
  .about-text
    padding: 2rem 5rem

@media (min-width: 576px)
  .about-section-image, .about-section-text
    height: 18rem !important
 
  .about-text
    padding-top: 3rem !important
    padding-bottom: 1.5rem !important
 
  .about-section-text h2
    font-size: 2.5em !important

@media (min-width: 992px)
  .about-section-image, .about-section-text
    height: 25rem !important
 
  .about-text
    padding-top: 4rem !important
    padding-bottom: 1.5rem !important
 
  .about-section-text h2
    font-size: 4em !important

@media (max-width: 575px)
  .about-section-component
    margin-top: 4rem !important
    margin-bottom: 4rem !important
  
@media (max-width: 767px)
  .about-text
    padding: 2rem !important

    h2
      text-align: center
      font-size: 2.2em
    
    p
      text-align: center
      font-size: 0.8em
</style>
